import {
    TextField, MenuItem, Select, InputLabel,
    FormControl, Button, Grid, Typography, Autocomplete, Checkbox, ListItemText
} from '@mui/material';
import { useEffect } from 'react';
import permissionProfileStore from '../../Mobx/PermissionProfileStore';

const UsersFilterPanel = ({
    filters, setFilters,
    sortField, setSortField,
    sortOrder, setSortOrder,
    fetchUsers,
    setPage,
    limit,
    setLimit,
    visibleFields,
    setVisibleFields
}) => {
    useEffect(() => {
        permissionProfileStore.fetchProfiles({
            page: 1,
            limit: 1000,
            filters: {},
            sort: [{ field: 'name', order: 'asc' }]
        });
    }, []);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setPage(1);
    };

    const resetFilters = () => {
        setFilters({
            firstName: '', lastName: '', nickname: '', email: '',
            role: '', subscriptionLevel: '', typeOfDictionary: '',
            learningLanguage: '', city: '', school: '', class: '',
            parentalControl: '', country: '',
            createdAt: { from: '', to: '' },
            serial: '', goalId: '', archive: 'false',
            permissionProfile: ''
        });
        // setSortField('createdAt');
        // setSortOrder('desc');
        // setLimit(10);
        setPage(1);
    };

    const allFields = [
        'profilePicture', '_id',
        'firstName', 'lastName',
        'email', 'password',
        'role', 'subscriptionLevel',
        'serial', 'goalId','typeOfDictionary',
        'createdAt', 'permissionProfile'
    ];

    const fieldLabels = {
        _id: 'ID',
        firstName: 'שם פרטי',
        lastName: 'שם משפחה',
        email: 'אימייל',
        password: 'סיסמה',
        role: 'תפקיד',
        createdAt: 'תאריך יצירה',
        typeOfDictionary: 'סוג מילון',
        subscriptionLevel: 'גישה',
        profilePicture: 'תמונת פרופיל',
        serial: 'קוד סיריאל',
        goalId: 'כיתה',
        archive: 'ארכיון',
        permissionProfile: 'פרופיל הרשאות'
    };

    const fieldOptions = allFields.map(field => ({
        label: fieldLabels[field] || field,
        value: field
    }));

    const selectAllOption = { label: 'בחר הכל', value: 'select_all' };
    const isAllSelected = visibleFields.length === allFields.length;
    const selectedFieldObjects = fieldOptions.filter(opt => visibleFields.includes(opt.value));

    const handleFieldSelect = (event, value, reason) => {
        if (reason === 'selectOption' && value.some(v => v.value === 'select_all')) {
            if (isAllSelected) {
                setVisibleFields([]);
            } else {
                setVisibleFields(allFields);
            }
        } else {
            setVisibleFields(value.filter(v => v.value !== 'select_all').map(v => v.value));
        }
    };

    return (
        <Grid container spacing={1} sx={{ padding: 1 }}>
            <Grid item xs={12}><Typography variant="subtitle1" sx={{ mb: 1 }}>סינון</Typography></Grid>

            {[
                ['firstName', 'שם פרטי'], ['lastName', 'שם משפחה'], ['email', 'אימייל מלא'], ['serial', 'קוד סיריאל'], ['goalId', 'כיתה']
                // ['city', 'עיר'], ['school', 'בית ספר'], ['class', 'כיתה'], ['country', 'מדינה'], ['nickname', 'כינוי']
            ].map(([key, label]) => (
                <Grid item xs={6} key={key}>
                    <TextField
                        label={label}
                        value={filters[key]}
                        onChange={e => handleChange(key, e.target.value)}
                        size="small"
                        fullWidth
                    />
                </Grid>
            ))}

            {[
                ['role', 'תפקיד', ['teacher', 'student', 'admin', 'withoutRole'], ['מורה', 'תלמיד', 'מנהל', 'ללא תפקיד']],
                ['subscriptionLevel', 'גישה', [-2, -1, 0, 1], ['קוד סיריאל', 'עובד החברה', 'חסום', 'משלם']],
                ['typeOfDictionary', 'סוג מילון', ['universal', 'olami'], ['אוניברסלי', 'עולמי']],
                ['archive', 'ארכיון', ['false', 'true'], ['לא בארכיון', 'בארכיון']],
                // ['learningLanguage', 'שפת לימוד', ['en', 'he'], ['אנגלית', 'עברית']],
                // ['parentalControl', 'בקרת הורים', ['true', 'false'], ['מופעל', 'כבוי']]
            ].map(([key, label, values, names]) => (
                <Grid item xs={6} key={key}>
                    <FormControl fullWidth size="small">
                        <InputLabel>{label}</InputLabel>
                        <Select
                            value={filters[key]}
                            onChange={e => handleChange(key, e.target.value)}
                            label={label}
                        >
                            <MenuItem value="">הכל</MenuItem>
                            {values.map((val, i) => (
                                <MenuItem key={val} value={val}>
                                    {names ? names[i] : val}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            ))}

            {/* סינון לפי permissionProfile */}
            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>פרופיל הרשאות</InputLabel>
                    <Select
                        value={filters.permissionProfile}
                        onChange={e => handleChange('permissionProfile', e.target.value)}
                        label="פרופיל הרשאות"
                    >
                        <MenuItem value="">הכל</MenuItem>
                        {permissionProfileStore.profiles.map(profile => (
                            <MenuItem key={profile._id} value={profile._id}>
                                {profile.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            label="נוצר מתאריך"
                            type="date"
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={filters.createdAt?.from || ''}
                            onChange={e => handleChange('createdAt', { ...filters.createdAt, from: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label="עד תאריך"
                            type="date"
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={filters.createdAt?.to || ''}
                            onChange={e => handleChange('createdAt', { ...filters.createdAt, to: e.target.value })}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12}><Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>מיון</Typography></Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>שדה</InputLabel>
                    <Select
                        value={sortField}
                        onChange={e => { setSortField(e.target.value); setPage(1); }}
                        label="שדה"
                    >
                        {[
                            ['createdAt', 'תאריך יצירה'],
                            ['firstName', 'שם פרטי'],
                            ['lastName', 'שם משפחה'],
                            ['email', 'אימייל'],
                            ['role', 'תפקיד'],
                            ['subscriptionLevel', 'גישה'],
                            ['profilePicture', 'תמונת פרופיל'],
                            ['password', 'סיסמה'],
                            ['serial', 'קוד סיריאל'],
                            ['goalId', 'כיתה']
                        ].map(([value, label]) => (
                            <MenuItem key={value} value={value}>{label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>סדר</InputLabel>
                    <Select value={sortOrder} onChange={e => { setSortOrder(e.target.value); setPage(1); }} label="סדר">
                        <MenuItem value="asc">עולה</MenuItem>
                        <MenuItem value="desc">יורד</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12}><Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>כמות בעמוד</Typography></Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>כמות בעמוד</InputLabel>
                    <Select value={limit} onChange={e => { setLimit(Number(e.target.value)); setPage(1); }} label="כמות בעמוד">
                        {[5, 10, 20, 50, 100].map(num => (
                            <MenuItem key={num} value={num}>{num}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} container spacing={1} justifyContent="flex-end" sx={{ mt: 1 }}>
                <Grid item>
                    <Button variant="contained" onClick={fetchUsers} size="small">חיפוש</Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" color="secondary" onClick={resetFilters} size="small">איפוס</Button>
                </Grid>
            </Grid>

            <Grid item xs={12}><Typography variant="subtitle1" sx={{ mt: 1, mb: 0 }}>עמודות להצגה</Typography></Grid>
            <Grid item xs={12} sx={{ mt: 0 }}>
                <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[selectAllOption, ...fieldOptions]}
                    getOptionLabel={(option) => option.label}
                    value={isAllSelected ? [selectAllOption, ...selectedFieldObjects] : selectedFieldObjects}
                    onChange={handleFieldSelect}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderOption={(props, option, { selected }) => (
                        <li {...props} style={{ textAlign: 'left', direction: 'ltr' }}>
                            <Checkbox
                                checked={selected || (option.value === 'select_all' && isAllSelected)}
                                style={{ marginLeft: 8 }}
                            />
                            <ListItemText primary={option.label} />
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField {...params} variant="outlined" size="small" placeholder="בחר עמודות להצגה" />
                    )}
                />
            </Grid>
        </Grid>
    );
};

export default UsersFilterPanel;
